// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BZ2_GET_PLAN = "Aktivuj si";
